var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.genderChart)?_c('pie-chart',{key:"genderChart",attrs:{"chart-data":_vm.genderChart,"tooltips-callback-cfg":_vm.tooltipsCallbackCfg,"width":_vm.width,"height":_vm.height}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }